import React, {ReactElement} from 'react';
import {Body, Content, Footer, Prefix, Title, ZeeroPopup} from "../../custom/ZeeroPopup";
import {faTriangleExclamation} from "@awesome.me/kit-92187fb46c/icons/classic/solid";
import ZeeroButton from "../../custom/ZeeroButton";
import {Trans, useTranslation} from "react-i18next";

const {FontAwesomeIcon} = await import("@fortawesome/react-fontawesome");

export default function MismatchConfirmationPopup({setShowConfirmationPopup, upload}: {
	setShowConfirmationPopup: (v: boolean) => void; upload: () => void;
}): ReactElement {
	const {t} = useTranslation();

	return (
			<ZeeroPopup>
				<Prefix>
					<FontAwesomeIcon icon={faTriangleExclamation} size="2xl" style={{color: "var(--warn)"}}/>
				</Prefix>
				<Content>
					<Title>{t("cdUpload_dataMismatchPopupTitle")}</Title>
					<Body>
						<Trans t={t} i18nKey="cdUpload_dataMismatchPopupBody" components={{br: <br/>}}/>
					</Body>
				</Content>
				<Footer>
					<ZeeroButton size="xs" type="secondary" onClick={() => setShowConfirmationPopup(false)}>
						{t("general_cancel")}
					</ZeeroButton>
					<ZeeroButton
							size="xs"
							type="primary"
							onClick={() => {
								setShowConfirmationPopup(false);
								void upload();
							}}
					>
						{t("general_upload")}
					</ZeeroButton>
				</Footer>
			</ZeeroPopup>
	);
}
